import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Pagination from "./Pagination";
import CardList from "./CardList";
import './UserProfile.css';
import { useUser } from '../UserContext';
import moment from 'moment';
import { ProgressBar, Placeholder } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Link } from "react-router-dom";
import { buildUrlWithParams } from "./utils";
import ActiveFilters from './ActiveFilters';
import { useModeratorAction } from '../ModeratorActionContext';
import { FaShieldAlt } from 'react-icons/fa';

const UserProfile = () => {
  const { userId, tab } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [userData, setUserData] = useState(null);
  const [userCards, setUserCards] = useState([]);
  const [userFavorites, setUserFavorites] = useState([]);
  const [userComments, setUserComments] = useState([]);
  const [userAchievements, setUserAchievements] = useState([]);
  const [activeTab, setActiveTab] = useState(tab || 'cards');
  const [totalPages, setTotalPages] = useState(1);
  const { user, setUser, setSelectedCard, settings, setSettings, filters, setFilters } = useUser();
  const params = new URLSearchParams(location.search);
  const [currentPage, setCurrentPage] = useState(parseInt(params.get('page'), 10) || 1);
  const [loading, setLoading] = useState(true);
  const [achievementProgress, setAchievementProgress] = useState(0); // Add state for progress percentage
  const fileInputRef = useRef(null);

  const { openModModal } = useModeratorAction();

  const handleBanUser = (userId) => {
    openModModal('user', userId);
  };


  useEffect(() => {
    //console.log(parseInt(params.get('page'), 10) || 1);
    setCurrentPage(parseInt(params.get('page'), 10) || 1);
  }, [location]);

  useEffect(() => {
    setActiveTab(tab || 'cards');
  }, [tab]);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     setLoading(true);
  //     try {
  //       // Fetch user data
  //       const userDataResponse = await axios.get(`/api/users/user.php?userId=${userId}`);
  //       setUserData(userDataResponse.data);
  //       setActiveTab('cards');
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, [userId]);


  useEffect(() => {
    setUserComments([]);
    setUserCards([]);
    setUserFavorites([]);
    setUserAchievements([]);
    const fetchData = async () => {
      try {
        const userDataResponse = await axios.get(`/api/users/user.php?userId=${userId}`);
        setUserData(userDataResponse.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [userId]);

  useEffect(() => {
    const newFilters = {
        class: params.get('class') || '',
        cost: params.get('cost') || '',
        attack: params.get('attack') || '',
        health: params.get('health') || '',
        category: params.get('category') || '',
        cardtype: params.get('cardtype') || '',
        search: params.get('search') || '',
        startDate: params.get('startDate') || '',
        endDate: params.get('endDate') || '',
        order: params.get('order') || '',
    };

    if (JSON.stringify(filters) !== JSON.stringify(newFilters)) {
        setCurrentPage(1);
        setFilters(newFilters);
    }
    setCurrentPage(parseInt(params.get('page'), 10) || 1);
}, [location]);

  useEffect(() => {
    if (filters.length === 0) {
      return;
    }
    if (currentPage === 0) {
      return;
    }
    const fetchData = async () => {
      //setLoading(true);
      try {

        // Fetch data based on active tab
        if (activeTab === "comments") {
          const commentsResponse = await axios.get(`/api/users/user_comments.php?userId=${userId}&page=${currentPage}`);
          setUserComments(commentsResponse.data.comments);
          setTotalPages(commentsResponse.data.totalPages);
        } else if (activeTab === "cards") {
          //const cardsResponse = await axios.get(`/api/json_custom_react.php?deckid=500&user_id=${userId}&page=${currentPage}`);

          const cardsResponse = await axios.get(`/api/json_custom_react.php`, {
            params: {
              search: filters.search,
              page: currentPage,
              class: filters.class,
              mana: filters.cost,
              attack: filters.attack,
              health: filters.health,
              deckid: '500',
              user_id: userId,
              startDate: filters.startDate,
              endDate: filters.endDate,
              cardtype: filters.cardtype,
              language: settings.language,
              order: filters.order,
            }
          });

          setUserCards(cardsResponse.data.cards);
          setTotalPages(cardsResponse.data.main.maxpage);
        } else if (activeTab === "favorites") {
          const favoritesResponse = await axios.get(`/api/json_custom_react.php?deckid=501&user_id=${userId}&page=${currentPage}`);
          setUserFavorites(favoritesResponse.data.cards);
          setTotalPages(favoritesResponse.data.main.maxpage);
        } else if (activeTab === "achievements") {
          const achievementsResponse = await axios.get(`/api/users/user_achievements.php?userId=${userId}`);
          const achievements = achievementsResponse.data.achievements;

// Exclude achievements with ids 33, 34, 35 from the calculation
const filteredAchievements = achievements.filter(
  (achievement) => ![23, 24, 25, 33, 34, 35].includes(Number(achievement.id))
);

          
          const totalAchievements = filteredAchievements.length;
          const earnedAchievements = filteredAchievements.filter(a => Number(a.earned) === 1).length;
  
          const progressPercentage = totalAchievements > 0 ? (earnedAchievements / totalAchievements) * 100 : 0;
          setAchievementProgress(progressPercentage);
  
          setUserAchievements(achievements);

        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [userId, activeTab, currentPage, filters]);

  const handleCategoryChange = (category) => {
    setTotalPages(0);
    setActiveTab(category);
    setCurrentPage(1);
  };

  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("image", file);
      formData.append("userId", userId);

      try {
        const response = await axios.post("/api/users/upload_image.php", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (response.data.success) {
          setUserData({ ...userData, profile_picture: response.data.imageUrl });
          setUser({
            ...user,
            profile_picture: response.data.imageUrl,
          });
        } else {
          console.error("Image upload failed:", response.data.message);
        }
      } catch (error) {
        console.error("Error uploading image:", error);
      }
    }
  };

  const renderProfilePlaceholder = () => (
    <div className="d-flex align-items-center mb-3 mx-2 mx-md-4 pt-4">
      <div className="me-3 col-auto align-self-start">
        <Placeholder
          animation="glow"
          className="rounded-circle"
          style={{
            width: "130px",
            height: "130px",
            display: "inline-block"
          }}
        >
          <Placeholder xs={12} style={{ height: "100%" }} />
        </Placeholder>
      </div>
      <div className="text-start col">
        <Placeholder as="h3" animation="glow">
          <Placeholder xs={6} />
        </Placeholder>
        <Placeholder as="p" animation="glow">
          <Placeholder xs={8} /> <Placeholder xs={4} />
        </Placeholder>
        <Placeholder as="p" animation="glow">
          <Placeholder xs={6} /> <Placeholder xs={5} />
        </Placeholder>
      </div>
    </div>
  );

  const renderContentPlaceholder = () => (
    <div className="pt-3">
      <Placeholder as="div" animation="glow">
        <Placeholder xs={12} size="lg" className="mb-3" />
      </Placeholder>
    </div>
  );

  return (
    <div>
      {loading ? renderProfilePlaceholder() : (
        userData && (
          <div className="d-flex align-items-center mb-3 mx-2 mx-md-4 pt-4">
            <div className="me-3 position-relative profile-image-container col-auto align-self-start">
              <img
                // src={userData.profile_picture ? `/images/users/pictures/${userData.profile_picture}` : "/gallery/images/profile-image.jpg"}
                src={
                  userData.profile_picture 
                    ? (userData.profile_picture.includes('http') 
                      ? userData.profile_picture 
                      : `/images/users/pictures/${userData.profile_picture}`)
                    : "/gallery/images/profile-image.jpg"
                }
                
                alt="Profile"
                className="rounded-circle img-thumbnail"
                style={{ width: "130px", height: "130px", objectFit: "cover" }}
              />
              {user && Number(userData.id) === Number(user.userid) && (
                <div className="edit-overlay user-select-none" onClick={handleImageClick} style={{ cursor: "pointer" }}>
                  Edit
                </div>
              )}
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
            </div>
            <div className="text-start col">
              <h3>{userData.username}
              {user && user.mod === true && Number(user.userid) !== Number(userData.id) && (	
                <button className="btn btn-danger btn-sm ms-2 mb-1" onClick={() => handleBanUser(userData.id)}><FaShieldAlt /> Ban User</button>
              )}
              </h3>
              {userData.regDate !== 0 && userData.regDate && (
                <p>
                  <strong>Account Created:</strong> {userData.regDate ? moment.unix(userData.regDate).fromNow() : 'N/A'}
                </p>
              )}
              <p>
                <strong>Total Cards:</strong> {userData.total_cards} <strong>Gallery Cards:</strong> {userData.gallery_cards}
              </p>
              <p>
                <strong>Average Rating of Gallery Cards:</strong> {userData.avg_rating ? userData.avg_rating.toFixed(2) : 'N/A'}
              </p>
            </div>
          </div>
        )
      )}
      <ul className="user-profile-tabs nav nav-tabs mx-2 mx-md-4">
        <li className="nav-item">
          <Link to={`/user/${userId}/cards`} style={{ textDecoration: 'none', color: 'inherit' }}
            className={`nav-link ${activeTab === "cards" ? "active" : ""}`}
            onClick={() => handleCategoryChange("cards")}>
            Cards
          </Link>
        </li>
        <li className="nav-item">
          <Link to={`/user/${userId}/comments`} style={{ textDecoration: 'none', color: 'inherit' }}
            className={`nav-link ${activeTab === "comments" ? "active" : ""}`}
            onClick={() => handleCategoryChange("comments")}>
            Comments
          </Link>
        </li>
        <li className="nav-item">
          <Link to={`/user/${userId}/favorites`} style={{ textDecoration: 'none', color: 'inherit' }}
            className={`nav-link ${activeTab === "favorites" ? "active" : ""}`}
            onClick={() => handleCategoryChange("favorites")}>
            Favorites
          </Link>
        </li>
        <li className="nav-item">
          <Link to={`/user/${userId}/achievements`} style={{ textDecoration: 'none', color: 'inherit' }}
            className={`nav-link ${activeTab === "achievements" ? "active" : ""}`}
            onClick={() => handleCategoryChange("achievements")}>
            Achievements
          </Link>
        </li>
      </ul>
      {loading ? renderContentPlaceholder() : (
        <>
          {activeTab === "about" && (
            <div>
              <h3>About</h3>
              <p>{userData ? userData.about : "Loading..."}</p>
            </div>
          )}
          {activeTab === "cards" && (
            <div className="pt-3">
              <ActiveFilters filters={filters} handleRemoveFilter={(filterName) => {
    setFilters({ ...filters, [filterName]: '' });
    setCurrentPage(1);
  }} />
              <CardList cards={userCards} loading={loading} settings={settings} />
              {totalPages > 1 && (
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={setCurrentPage}
                />
              )}
            </div>
          )}
          {activeTab === "favorites" && (
            <div className="pt-3">
              <CardList cards={userFavorites} loading={loading} settings={settings} />
              {totalPages > 1 && (
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={setCurrentPage}
                />
              )}
            </div>
          )}
          {activeTab === "achievements" && (
            <div className="pt-3 mt-3">
              <div className="container my-3 px-5 pb-3">
                <ProgressBar now={achievementProgress} label={`${achievementProgress.toFixed(0)}%`} />
              </div>

              
              {userAchievements.map((achievement) => (
                <div key={achievement.id} className="d-flex mb-3" style={{ opacity: Number(achievement.earned) === 0 ? 0.5 : 1 }}>
                  <div className="me-3">
                    <img
                      src="/images/trophy.png"
                      alt="Achievement"
                      className=""
                      style={{ height: "100px", width: "100px" }}
                    />
                  </div>
                  <div className="text-start">
                    {achievement.cardid ?
                      <h4 className="text-decoration-underline" style={{ cursor: "pointer" }} >
                        {achievement.name}
                      </h4>
                      :
                      <h4>{achievement.name}</h4>
                    }
                    <p>{achievement.description}</p>
                    {achievement.cardid && achievement.usercardid && (
                      <div className="mt-3">
                        <Link
                          to={`?selectedCard=${achievement.cardid}`}
                          style={{ textDecoration: 'none' }}
                        ><img
                            src={`/cards/${achievement.usercardid}.webp`}
                            className="img-fluid my-3"
                            alt={`Card ${achievement.usercardid}`}
                            style={{ maxWidth: '200px', cursor: 'pointer' }}
                          /></Link>
                      </div>
                    )}
                    {Number(achievement.earned) === 1 && (
                      <p>
                        <strong>Date Earned:</strong> {moment.unix(achievement.earned_at).format("MMMM Do YYYY, h:mm:ss a")}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
          {activeTab === "comments" && (
            <div className="pt-5 px-2 px-md-4">
              {userComments.map((comment) => (
                <div key={comment.id} className="d-flex mb-3">
                  <div className="me-3">
                    <Link
                      to={buildUrlWithParams({ ...Object.fromEntries(new URLSearchParams(window.location.search)), selectedCard: comment.card_id })}
                      style={{ textDecoration: 'none' }}
                    ><img
                        src={`/cards/${comment.cardid}.webp`}
                        alt="User"
                        className=""
                        style={{ height: "200px", width: "auto" }}
                      /></Link>
                  </div>
                  <div className="user-profile-comment text-start">
                    <p>{comment.comment}</p>
                    <p>
                      <strong>Date:</strong>{" "}
                      {new Date(comment.date * 1000).toLocaleString()}
                    </p>
                  </div>
                </div>
              ))}
              {totalPages > 1 && (
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={setCurrentPage}
                />
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default UserProfile;